import React from 'react'

export const StepTitle = ({ children }) => (
  <h3 className="step-title">{children}</h3>
)



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/StepInfo.jsx